var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "impersonate-notification" },
    [
      _c("CompassObject", { attrs: { object: "consent", size: "small" } }),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "typographies-heading-h4 impersonate-notification__content"
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$l10n.__(
                  "Demande d'accès %(type)s (pour une durée de %(duration)s)",
                  {
                    type: _vm.formatAccessType(_vm.authorization.type),
                    duration: "" + _vm.authorization.delay.label
                  }
                )
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "impersonate-notification__actions" },
        [
          _c("CompassButton", {
            ref: "acceptButton",
            attrs: {
              label: _vm.$t.__(
                "pages.settings.complianceImpersonate.ImpersonateNotification.grant_access"
              )
            },
            on: { click: _vm.handleAccept }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            ref: "refuseDialogButton",
            attrs: {
              label: _vm.$t.__(
                "pages.settings.complianceImpersonate.ImpersonateNotification.refuse_access"
              ),
              type: "secondary"
            },
            on: {
              click: function($event) {
                _vm.displayRefusalConfirmation = true
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          staticClass: "refusal-confirmation",
          attrs: {
            visible: _vm.displayRefusalConfirmation,
            size: "small",
            title: _vm.$t.__(
              "pages.settings.complianceImpersonate.ImpersonateNotification.refuse_access"
            )
          },
          on: {
            "update:visible": function($event) {
              _vm.displayRefusalConfirmation = $event
            },
            closed: function($event) {
              _vm.displayRefusalConfirmation = false
            }
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Vous êtes sur le point de refuser l’accès à votre compte aux collaborateurs Sellsy. Cette action est définitive, êtes-vous certain de vouloir refuser cet accès ?"
                    )
                  ) +
                  "\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__("common.actions.cancel"),
                  type: "secondary"
                },
                on: {
                  click: function($event) {
                    _vm.displayRefusalConfirmation = false
                  }
                }
              }),
              _vm._v(" "),
              _c("CompassButton", {
                ref: "refuseButton",
                attrs: {
                  label: _vm.$t.__(
                    "pages.settings.complianceImpersonate.ImpersonateNotification.refuse_access"
                  ),
                  type: "primary-destructive"
                },
                on: { click: _vm.handleRefusal }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }